import { Stack, Typography } from '@mui/material'
import { BrainCircuit20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'

export default function UsedMemoryIndicator({ memoryIds = [] }) {
  if (!memoryIds.length) return null

  return (
    <Tooltip text={`${memoryIds.length} memory ${memoryIds.length === 1 ? 'entry' : 'entries'} informed this reply`}>
      <Stack direction="row" sx={{ gap: 0.5, alignItems: 'center', color: 'var(--app-text-tertiary)' }}>
        <BrainCircuit20Regular fontSize={14} />
        <Typography sx={{ fontSize: 12 }}>Memory used</Typography>
      </Stack>
    </Tooltip>
  )
}
